export const HEIGHT_OFFSET = 76;
export const SCROLL_TOP_OFFSET = 34;

export const pageSettingsName = 'insights';
